import React from 'react';

const RedeemRewards = () => {
  return <div>Redeem Rewards</div>;
};

export default RedeemRewards;
